
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/come-back-vip",
      function () {
        return require("private-next-pages/come-back-vip.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/come-back-vip"])
      });
    }
  